import { createContext } from "react"

const InvoiceFormContext = createContext()

export default InvoiceFormContext
